module.exports = __webpack_public_path__ + "4ab15ae0a7cee0032aacada378bb1f7a.svg";


//////////////////
// WEBPACK FOOTER
// ./app/images/final-banner-mermaid.svg
// module id = 469
// module chunks = 0